'use es6';

import I18n from 'I18n';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import LegacyBoardContainerAsync from '../../../legacy/legacyBoard/LegacyBoardContainerAsync';
import SavedViewsTaskHeader from '../../components/views/SavedViewsTasksHeader';
import { PAGE_IDS } from '../../constants/pageConfigs';
import { useSelector } from '../../context/Redux';
import { getTaskByIdSelector } from '../../redux/selectors/tasks';
import { trackLegacyBoardPageview } from '../../tracking/tracker';
import { editTaskLink } from '../../utils/links';
import UIListingPage from 'UIComponents/page/UIListingPage';
import { MainContentWrapper } from '../MainContentWrapper';

// HACK: we have to reconcile the EngagementsStore's data to
// match the data from New Tasks' Redux store when a task is edited
import { jsx as _jsx } from "react/jsx-runtime";
export function _useLastEditedTask() {
  const {
    taskId = null
  } = useParams();
  const [lastTaskId, setLastTaskId] = useState(null);
  useEffect(() => {
    return () => {
      setLastTaskId(taskId);
    };
  }, [taskId]);
  return useSelector(getTaskByIdSelector)(lastTaskId);
}
export default function LegacyBoardPage() {
  useEffect(() => {
    document.title = I18n.text('crm-tasks-ui.titles.tasks');
    trackLegacyBoardPageview();
  }, []);
  const lastEditedTask = _useLastEditedTask();
  const history = useHistory();
  const {
    pathname
  } = useLocation();
  const handleTaskClicked = useCallback(taskId => {
    const target = editTaskLink(pathname, taskId, false);
    history.replace(target);
  }, [history, pathname]);
  return /*#__PURE__*/_jsx(UIListingPage, {
    headerComponent: /*#__PURE__*/_jsx(SavedViewsTaskHeader, {
      pageId: PAGE_IDS.LEGACY_BOARD
    }),
    pageLayout: "full-width",
    children: /*#__PURE__*/_jsx(MainContentWrapper, {
      children: /*#__PURE__*/_jsx(LegacyBoardContainerAsync, {
        onTaskClicked: handleTaskClicked,
        lastUpdatedTask: lastEditedTask
      })
    })
  });
}